import 'ui-core/plugins/drawer/js/drawer';
(function () {
    const menu = UX.menu;
    const $body = $('body');
    let mobileMenuController = function () {
        $('.menu-parent').each(function () {
            const $toggle = $(this);
            const $links = $toggle.find('>.dropdown__menu').find('a');
            $links.each(function () {
                $(this).on('click', function (e) {
                    e.stopPropagation(); // Prevent the event from reaching the parent
                });
            });
            $toggle.on('click', function (e) {
                if (menu.isMobile) {
                    const $menu = $toggle.find('>.dropdown__menu');
                    e.preventDefault();
                    if ($toggle.hasClass('js--open')) {
                        $toggle.removeClass('js--open');
                        $toggle.attr('aria-expanded', 'false');
                    } else {
                        $('.dropdown__menu.js--open').not($menu).removeClass('js--open');
                        $('.dropdown__toggle[aria-expanded="true"]').not($toggle).attr('aria-expanded', 'false');
                        $toggle.addClass('js--open');
                        $toggle.attr('aria-expanded', 'true');
                    }
                }
            });
        });
    };
    menu.additionalControl = () => {
        const $window = $(window),
            $document = $(document);
        const $homeMenu = $('.home-menu');

        if (!$homeMenu.length) {
            return;
        }
        $window.on('scroll', () => {
            const top = $document.scrollTop();
            if (top > 0) {
                $homeMenu.addClass('locked');
            } else {
                $homeMenu.removeClass('locked');
            }
        });
        // TODO: remove the below after ticket (LIT-612016) is merged into core https://github.com/atypon/ui-core/pull/1694
        $body.on('click', function (e) {
            $('[aria-expanded="true"]').attr('aria-expanded', 'false');
            if (!$(e.target).closest('.dropdown__toggle').length) {
                $('a.dropdown__toggle.hover').removeClass('hover');
            }
            if (
                !$(e.target).hasClass('icon-arrow_r') &&
                !$(e.target).parents('.main-nav__toggle__controller') &&
                !$(e.target).parents('.main-nav.menu--res').length &&
                $('.lock-screen[data-active="menu"]').length
            ) {
                menu.on.hide(e);
            }
        });
        mobileMenuController();
    };

    // TODO: remove the below after ticket (LIT-612016) is merged into core https://github.com/atypon/ui-core/pull/1694
    (menu.on.tabDesktop = function (e, revers, keyCode) {
        var $target = $(e.target);
        var $parentMenu = $target.closest('.dropdown__menu');
        var $dropdownToggle = $('.dropdown__toggle');
        var dropdownMenu = '.dropdown__menu';
        const menubar = $(e.target).closest('#menubar');
        if (!$target.closest('ul').length) {
            $dropdownToggle.removeClass('hover');
            $('.dropdown').removeClass('js--open');
        }
        if ($target.hasClass('dropdown__toggle')) {
            if (
                $parentMenu.length === 0 ||
                (!$parentMenu.hasClass('js--open') && $parentMenu.find('.js--open').length === 0)
            ) {
                $dropdownToggle.removeClass('hover');
                $(dropdownMenu).removeClass('js--open');
                $target.closest('a').addClass('hover');
                $target.siblings(dropdownMenu).addClass('js--open');
                $target.attr('aria-expanded', 'true');
            } else {
                $parentMenu.find('.hover').removeClass('hover');
                $parentMenu.find('.js--open').removeClass('js--open');
                $target.closest('a').addClass('hover');
                $target.siblings(dropdownMenu).addClass('js--open');
            }
            if (keyCode == 'Enter') {
                $(e.target).closest('a').addClass('hover');
            }
        } else {
            if (keyCode == 'Enter' && $target.attr('data-db-target-for')) {
                $target.attr('aria-expanded', function (index, attr) {
                    return attr === 'true' ? 'false' : 'true';
                });
            }
            if ($target.closest('.dropdown__menu').length) {
                $target.closest('.dropdown__menu').removeAttr('aria-hidden');
            }
            menubar.find('.dropdown__toggle.hover').attr('aria-expanded', 'true');
            $target.closest('ul').find('.hover').removeClass('hover');
            $target.closest('ul').removeClass('js--open');
        }
    }),
        (menu.init = () => {
            $('.main-nav').each(function (index) {
                menu.$target = $(this);
                const $header = menu.$target.find('.menu-header');
                menu.menuHeaderMainTitle = $header.text();
                menu.redirectPath = $header.data('redirect-to');
                menu.check.viewPort(index);
                menu.responsive(index);
            });
            $('.main-nav__toggle__controller').attr('aria-expanded', 'false');
            $('.dropdown__toggle').attr('aria-expanded', 'false');

            menu.items = $('.main-nav').find('a, button, input'); //$(".header__nav a, .header__nav button, .header__nav input");
            menu.control();
            menu.additionalControl();
        }),
        (UX.menu = menu); // add to global namespace
})();
